module.exports = __webpack_public_path__ + "static/media/unselectedWhite.f4b5a9de.svg";